export const TOAST_WRAPPER_ID = 'toast_wrapper';
export const TOAST_FADE_IN_MS = 200;
